// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pro[data-v-1f0c8727] {\n  padding: 0 15px;\n}\n.pro .tips[data-v-1f0c8727] {\n  height: 50px;\n  line-height: 50px;\n  color: #999;\n  font-size: 12px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n.pro .btn-box[data-v-1f0c8727] {\n  padding-bottom: 20px;\n}", ""]);
// Exports
module.exports = exports;
